export type LiveTrackingState = 'tracking' | 'idle' | 'stopped' | 'unknown';

export function getLiveTrackingLabel(state: LiveTrackingState): string {
  return { tracking: 'Tracking', idle: 'Idle', stopped: 'Not Tracking', unknown: 'Unavailable' }[state];
}
